<template>
  <el-upload
    :show-file-list="false"
    :on-success="handleAvatarSuccess"
    :before-upload="beforeAvatarUpload"
    :v-model="value"
    :headers="headers"
    :action="uploadUrl"
    class="avatar-uploader">
    <img v-if="showUrl" :src="showUrl" class="avatar" >
    <i v-else class="el-icon-plus avatar-uploader-icon"/>
  </el-upload>
</template>
<script>
    import {mapGetters} from "vuex";
    export default {
      name: "index.vue",
      props:{
        value: {
          type: String,
          'default': ''
        },
        width: {
          type: Number,
          'default': 200
        },
        height: {
          type: Number,
          'default': 200
        },
        url: {
          type: String,
          'default':''
        },
        imgFormat: {
          type: String,
          'default': 'png'
        },
      },
      data() {
        return {
          showUrl: this.url,
          srcList: [this.url],
          uploadUrl: process.env.VUE_APP_BASE_API + '/attach/upload',
        }
      },
      watch: {
        // 子组件修改value后同步到父组件
        url(newValue) {
          if(newValue){
            this.showUrl = process.env.VUE_APP_BASE_API+''+newValue
          }
        }
      },
      computed: {
          headers() {
            return {
              Authorization: `Bearer ${this.accessToken}`,
            };
          },
          ...mapGetters(['accessToken'])
      },
      methods: {
        // 宣传图上传成功回调
        handleAvatarSuccess(response, file) {
          if (response) {
            if (response.code == 0) {
              this.$emit('input', response.data.id)
              this.showUrl = process.env.VUE_APP_BASE_API +''+ response.data.attachUrl
              this.$emit('handleUploadSuccess',response.data)
            } else {
              this.$message.error("上传文件出错")
            }
          }
        },
        beforeAvatarUpload(file) {
          const isJPG = file.type === 'image/jpeg'
          const isPNG = file.type === 'image/png'
          const isLt5M = file.size / 1024 / 1024 < 5
          if (!isJPG && !isPNG) {
            this.$message.error('上传头像图片只能是JPG、JPEG、PNG 格式!')
          }
          if (!isLt5M) {
            this.$message.error('上传头像图片大小不能超过 5MB!')
          }
          return (isJPG || isPNG) && isLt5M
        }
      }
    }
</script>

<style scoped>
  .avatar-uploader .el-upload{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .avatar {
    width: 50px;
    height: 50px;
    display: block;
  }
</style>
